import { render, staticRenderFns } from "./SharedResumes.vue?vue&type=template&id=5d5f335d"
import script from "./SharedResumes.vue?vue&type=script&lang=js"
export * from "./SharedResumes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports